transformations = {
  "meta.pubtype": {
    "UM": "User’s manual",
    "GSG": "Getting Started",
    "technote": "Notice to customer"
  }
};
